function request<T>(onMessage: T, onError: T) {
	return {
		url: `/websocket/connect`,
		onMessage,
		contentType: 'application/json',
		transport: 'websocket',
		/*
		 * Handling reconnections manually to avoid dropped connections
		 */
		reconnect: false,
		timeout: 900_000, // 15 minutes timeout
		/**
		 * Handling client timeout and on close as an error to update the status accordingly
		 */
		onError,
		onClientTimeout: onError,
		onClose: onError
	};
}

export default request;
